import { render, staticRenderFns } from "./QRLandscape.vue?vue&type=template&id=6efd8b1a"
import script from "./QRLandscape.vue?vue&type=script&lang=js"
export * from "./QRLandscape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports